function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import classNames from 'classnames';
import React, { useState } from 'react';
import { renderErrors } from "../../utils";
import { hasError } from "../../utils/hasError/hasError";
import { Button } from '..';
import { ButtonTypes } from "../button/Button.types";
import { BackgroundIcon, CharsCouterContainer, CharsNumber, ClearIconWrapper, ErrorMessage, IconWrapper, InputContent, InputLabel, InputText, InputWrapper, MaxChars, ToggleValueIconWrapper } from "./Input.styles";
export var Input = function Input(_ref) {
  var input = _ref.input,
      disabled = _ref.disabled,
      meta = _ref.meta,
      label = _ref.label,
      icon = _ref.icon,
      style = _ref.style,
      clearable = _ref.clearable,
      className = _ref.className,
      isDense = _ref.isDense,
      toggleValue = _ref.toggleValue,
      charsCounter = _ref.charsCounter,
      maxLenght = _ref.maxLenght;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isValueVisible = _useState2[0],
      setValueVisibility = _useState2[1];

  var handleClear = function handleClear() {
    return input.onChange('');
  };

  var isError = hasError(meta, disabled);
  var iconSize = '1.5rem';
  var Icon = null;

  if (icon) {
    if (typeof icon === 'string') {
      Icon = function Icon(props) {
        return React.createElement(BackgroundIcon, _extends({
          icon: icon
        }, props));
      };
    } else if (Array.isArray(icon)) {
      Icon = icon[0] || Icon;
      iconSize = icon[1] || iconSize;
    } else {
      Icon = icon;
    }
  }

  var handleToggleValue = function handleToggleValue() {
    setValueVisibility(!isValueVisible);
  };

  var getInputType = function getInputType() {
    return isValueVisible ? 'text' : 'password';
  };

  var paddingStyle = {
    paddingLeft: Icon ? "calc(".concat(iconSize, " + 2rem)") : undefined,
    paddingRight: clearable ? '3rem' : undefined
  };

  var handleOnChange = function handleOnChange(event) {
    if (!maxLenght || event.target.value.length <= maxLenght) {
      input.onChange(event);
    } else {
      input.onChange(input.value);
    }
  };

  return React.createElement(InputWrapper, {
    style: style,
    className: classNames(className, 'input', isError && 'input--error')
  }, React.createElement(InputContent, {
    className: "input__content"
  }, React.createElement(InputText, _extends({}, input, {
    onChange: handleOnChange,
    isFilled: !!input.value,
    hasError: isError,
    isDense: isDense,
    isModified: meta.dirty,
    disabled: disabled,
    style: paddingStyle,
    className: classNames('input__field', isError && 'input__field--error'),
    type: toggleValue ? getInputType() : input.type,
    autoComplete: 'off'
  })), React.createElement(InputLabel, {
    style: paddingStyle,
    htmlFor: input.name,
    className: "input__label"
  }, label), Icon && React.createElement(IconWrapper, {
    style: Icon ? {
      margin: '0 1rem'
    } : undefined,
    className: "input__icon"
  }, React.createElement(Icon, {
    style: Icon ? {
      width: iconSize,
      height: iconSize
    } : undefined
  })), clearable && input.value && React.createElement(ClearIconWrapper, {
    className: "input__clear-button-wrapper"
  }, React.createElement(Button, {
    className: "input__clear-button",
    type: ButtonTypes.ICON,
    onClick: handleClear,
    icon: 'closeM'
  })), toggleValue && input.value && React.createElement(ToggleValueIconWrapper, null, React.createElement(Button, {
    type: ButtonTypes.ICON,
    onClick: handleToggleValue,
    icon: 'eye',
    htmlType: "button"
  })), charsCounter && React.createElement(CharsCouterContainer, null, React.createElement(CharsNumber, {
    className: "input__chars-number"
  }, input.value.length), maxLenght && React.createElement(MaxChars, {
    className: "input__max-number"
  }, "/", maxLenght))), isError && React.createElement(ErrorMessage, {
    className: "input__error"
  }, renderErrors(meta.error, meta.submitError)));
};